var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconArrowThickCircleUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm6.29 12H14.5a.25.25 0 0 0-.25.25v6.25a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5v-6.25A.25.25 0 0 0 9.5 12H5.72a.5.5 0 0 1-.36-.85l6.29-6.29a.51.51 0 0 1 .71 0l6.28 6.29a.5.5 0 0 1-.35.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconArrowThickCircleUp);
export default __webpack_public_path__ + "static/media/streamline-icon-arrow-thick-circle-up.0273322e.svg";
export { ForwardRef as ReactComponent };